<span
  class="flex h-10 w-10 items-center justify-center rounded-full bg-[var(--primary-40)] text-base text-[var(--primary-90)]"
  >{{ nameInitials() }}</span
>
